import React, { useState } from 'react';
import './SignUpPage.css';

function SignUpPage() {
  const [formData, setFormData] = useState({
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    phone_number: '',
    role: 'ADMIN',
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const { email, first_name, last_name, password, phone_number } = formData;
    if (!email || !first_name || !last_name || !password || !phone_number) {
      setError('All fields are required');
      return false;
    }
    return true;
  };

  const handleSignUp = async () => {
    if (!validateForm()) {
        return;
      }
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/registration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSuccessMessage('Account created successfully! Please log in.');
        setError('');
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Sign up failed');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-left">
        <div className="quote-container">
          <h4>Laki</h4>
          <h1>Money Market Funds</h1>
          {/* <p>Join us and get everything you want by working hard and trusting the process.</p> */}
        </div>
      </div>
      <div className="signup-right">
        <div className="signup-form-container">
          <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="Logo" className="logo"/>
          <h2>Join Us</h2>
          <p>Fill in the details below to create your account</p>
          {error && <p className="error-login">{error}</p>}
          {successMessage && <p className="success">{successMessage}</p>}
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="text"
            name="first_name"
            placeholder="Enter your first name"
            value={formData.first_name}
            onChange={handleChange}
          />
          <input
            type="text"
            name="last_name"
            placeholder="Enter your last name"
            value={formData.last_name}
            onChange={handleChange}
          />
          <input
            type="password"
            name="password"
            placeholder="Enter your password"
            value={formData.password}
            onChange={handleChange}
          />
          <input
            type="text"
            name="phone_number"
            placeholder="Enter your phone number"
            value={formData.phone_number}
            onChange={handleChange}
          />
          <button onClick={handleSignUp} className="sign-in-btn">Sign Up</button>
          <p>
            Already have an account? <a href="/login">Log In</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default SignUpPage;
